import dateFromArgs from '../helpers/date-from-args';

export default function isValidDate(value) {
    var date = value.split('-');
    var y = date[0];
    var m = date[1];
    var d = date[2];
    var newDate = `${m}/${d}/${y}`;
    var pattern = /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)(\d{2})/
    var m = newDate.match(pattern);
    if (!m)
        return false;
    var d = new Date(newDate);
    // Now let's ensure that the date is not out of index

    if (d.getMonth() + 1 == parseInt(m[1], 10) && d.getDate() == parseInt(m[2], 10)) {
        return true;
    }
    return false;
}